<template>
    <div class="question-item">
        <div class="question-content">
            <div class="question-title">
                <TextTemplate class="title" :text="question.title" v-if="question.title" />
                <TextTemplate v-if="question.content" :text="question.content" />
                <AudioPlayer v-if="question.audioUrl" :audioSrc="question.audioUrl" />
                <ImagePreview :picUrl="question.picUrl" v-if="question.picUrl" />
            </div>
        </div>
        <div class="question-list">
            <div v-if="'LISTENING_BLANK' === question.type" class="listening-blank">
                <Blank
                    :show="true"
                    :ref="`question${item.indexNo}`"
                    v-for="item in question.childQuestions"
                    :key="item.id"
                    :question="item"
                    :type="item.type"
                />
            </div>
            <div v-else-if="['LISTENING_MATCH', 'COMPREHENSION_MATCH'].includes(question.type)" class="listening-match">
                <!-- jumpQuestion 使用 -->
                <div :ref="`question${item.indexNo}`" v-for="item in question.childQuestions" :key="item.id"></div>
                <Match :question="question" />
            </div>
            <template v-else>
                <div :ref="`question${item.indexNo}`" v-for="item in question.childQuestions" :key="item.id">
                    <Choice :show="true" :question="item" v-if="['SINGLE_CHOICE', 'JUDGMENT'].includes(item.type)" />
                    <MuletpleChoice :show="true" :question="item" v-if="item.type === 'MULTIPLE_CHOICE'" />
                    <Blank
                        :show="true"
                        :question="item"
                        :type="item.type"
                        v-if="['DISORDER_BLANK', 'ORDER_BLANK'].includes(item.type)"
                    />
                    <Writing :show="true" :question="item" v-if="item.type === 'WRITING'" />
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import TextTemplate from '../../TextTemplate.vue'
import ImagePreview from '../../ImagePreview.vue'
import AudioPlayer from '../../AudioPlayer.vue'
import Choice from './Choice.vue'
import MuletpleChoice from './MuletpleChoice.vue'
import Blank from './Blank.vue'
import Writing from './Writing.vue'
import Match from './Match.vue'

export default {
    props: ['question'],
    components: { TextTemplate, ImagePreview, AudioPlayer, Choice, MuletpleChoice, Blank, Writing, Match },
    computed: {
        jumpQuestion() {
            return this.$store.state.paperResult.jumpQuestion
        },
    },
    watch: {
        jumpQuestion: function () {
            if (this.question.childQuestions) {
                this.question.childQuestions.forEach((item) => {
                    if (item.id === this.jumpQuestion.subQuestionId) {
                        let _el = this.$refs[`question${item.indexNo}`][0]
                        if (!_el.scrollIntoView) {
                            _el = _el.$el
                        }
                        _el.scrollIntoView({
                            block: 'start',
                        })
                    }
                })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.question-list {
    margin-top: 16px;
    background: #f8f8f8;
}
</style>
